import { useEffect, useMemo, useState } from 'react';
import type { TakiSdk } from '@taki/sdk';
import type { LiaConversationsPort, LiaSujetView } from '@taki/ui';

/**
 * LES CONVERSATIONS AVEC LIA, reliees au shell par l'hote (le shell n'a pas le
 * SDK, comme pour les reglages IA). Le port observe les sujets de la personne
 * connectee des qu'elle l'est, et les rend au centre de communication.
 */
export function useLiaConversationsDeLHote(sdk: TakiSdk, uid: string | null): LiaConversationsPort {
  const [sujets, setSujets] = useState<LiaSujetView[]>([]);
  useEffect(() => {
    if (uid === null) { setSujets([]); return; }
    return sdk.liaConversations.observer((liste) => setSujets(liste), () => setSujets([]));
  }, [sdk, uid]);

  return useMemo<LiaConversationsPort>(() => ({
    observerReponses: (proprietaire, sujetId, recevoir, erreur) => sdk.liaConversations.observerReponses(proprietaire, sujetId, recevoir, erreur),
    observer(onValue, onError) {
      // Une seule souscription SDK par hote : les abonnes du shell recoivent la meme liste.
      onValue(sujets);
      if (uid === null) return () => {};
      return sdk.liaConversations.observer(onValue, onError);
    },
    enregistrer: (sujet) => sdk.liaConversations.enregistrer(sujet),
    renommer: (id, titre) => sdk.liaConversations.renommer(id, titre),
    archiver: (id) => sdk.liaConversations.archiver(id),
    desarchiver: (id) => sdk.liaConversations.desarchiver(id),
    partager: (id, personIds) => sdk.liaConversations.partager(id, personIds),
    retirerPartage: (id, personIds) => sdk.liaConversations.retirerPartage(id, personIds),
    observerPartagesAvecMoi: (onValue, onError) => uid === null ? () => {}
      : sdk.liaConversations.observerPartagesAvecMoi((liste) => onValue(liste.map(({ proprietaireUid, ...sujet }) => ({ ...sujet, uid: proprietaireUid }))), onError),
  }), [sdk, uid, sujets]);
}
